<template>
    <div>
        <template v-if="loading">
            <Loading :show="loading"/>
        </template>
        <template v-else>
            <div class="accordion" role="tablist" v-if="voteList">
                <b-card no-body class="mb-1" v-for="(item,index) in voteList" :key="item.id">
                    <b-card-header header-tag="header" class="p-1" role="tab">
                        <b-alert show v-b-toggle="'accordion-'+item.id" variant="primary" class="mb-0"><i class="ri-focus-line"></i> {{item.name}}</b-alert>
                    </b-card-header>
                    <b-collapse :id="'accordion-'+item.id" :visible="index == 0" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                            <b-card-text>{{item.description}}</b-card-text>
                            <b-card-text>
                                <b-form-group v-slot="{ ariaDescribedby }">
                                    <b-form-radio
                                        v-for="option in item.options"
                                        @change="selectOption(option)"
                                        :key="option.id"
                                        v-model="option.checked"
                                        :aria-describedby="ariaDescribedby"
                                        :name="'some-radios-'+item.id+option.id"
                                        :id="'some-radios-'+item.id+option.id"
                                        :value="option.id"
                                        :disabled="currentDateNow > $moment(item.end_date).format('X') || (item.type==='president' && item.options.some(o => o.checked))"
                                        class="mb-2">{{option.option}}</b-form-radio>
                                </b-form-group>
                            </b-card-text>
                        </b-card-body>

                    </b-collapse>
                </b-card>
            </div>
        </template>
    </div>
</template>

<script>
    //Component

    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    import moment from "moment"
    //Service
    import StudentClubService from "@/services/StudentClubService"

    export default {
        props: {
            clubData: {
                type: Object,
            }
        },

        components: {
            ValidationProvider,
            ValidationObserver,

        },

        data() {
            return {
                voteList: null,
                currentDateNow: null,
                loading: false
            }
        },

        methods: {
            getClubVoteList(){
                this.loading = true

                StudentClubService.getMyClubVoteList(this.clubData.student_club_id).then(response => {
                    let data = response.data.data
                    data.forEach((item,index) => {
                        StudentClubService.getMyClubVoteAnswer(item.id).then(response => {
                            let odata = response.data.data
                            item.options.forEach((opt, idx) => {
                                if(opt.id == odata.student_club_vote_option_id && opt.student_club_vote_id == odata.student_club_vote_id){
                                    data[index].options[idx].checked = opt.id
                                }
                            })
                        })

                    })
                    setTimeout(() => {
                        this.voteList = data
                    }, 500)
                }).catch(e => {
                    this.showErrors(e, null)
                }).finally(() => {
                    this.loading = false
                })
            },

            selectOption(value){
                let formData = {
                    student_club_vote_id: value.student_club_vote_id,
                    student_club_vote_option_id: value.id
                }
                StudentClubService.voteAnswer(formData).then(response => {
                    this.$toast.success(this.$t('api.'+response.data.message))
                    this.getClubVoteList()
                }).catch(e => {
                    this.showErrors(e, null)
                })
            }
        },

        created() {
            this.currentDateNow = moment().format("X")
            this.getClubVoteList()
        },

    }
</script>
